import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "search-64", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 51 51", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor", strokeWidth: 2.5 },
        React.createElement("circle", { cx: 22.5, cy: 22.5, r: 15.25 }),
        React.createElement("path", { strokeLinecap: "round", d: "m43.5 43.5-9.75-9.75" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
